import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Scroll } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  logo:string = 'assets/images/ic_icon.png';
 // isSticky:boolean = true;
  collapsed = true;
  @Input() isSticky!: boolean

  constructor(){

  }

  @HostListener('window:scroll', ['$event'])

  ngOnInit(): void {
    
  }
  toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
  }

  checkScroll(event:any){
    console.log(event)
    //this.isSticky = window.scrollY >= 250;
  }
  
}
